<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="500px"
			center
			:append-to-body='true'
			@close="closeWin"
			:visible.sync="showJfWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData2">
				<el-form ref="form" :model="formData" class="formWrap" :rules="rules">
					<el-form-item label="经费名称" class="form_item" prop="allocate_class">
						<el-input v-model="formData.allocate_class"  placeholder="请输入经费名称"></el-input>
					</el-form-item>
					<el-form-item class="form_item" label="选择时间" prop="allocate_time">
						<el-date-picker
							format="yyyy-M-d"
							value-format="yyyy-M-d"
							v-model="formData.allocate_time"
							type="date"
							placeholder="选择时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item
						v-if="type=='add'" class="form_item" label="经费分类" prop="funds_class">
						<el-select
							clearable
							v-model="formData.funds_class" placeholder="请选择分类">
							<el-option
								v-if="$store.state.user.userinfo.flag != 3"
								label="经费下拨"
								value="1">
							</el-option>
							<el-option
								label="经费支出"
								value="2">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="下拨组织" class="form_item" prop="uid" 
					v-if="formData.funds_class==1">
						<el-select
							value-key="id"
							@change="changeDw"
							v-model="arr"
							multiple
							collapse-tags
							placeholder="选择下拨组织">
							<el-option
								:key="index"
								v-for="(item,index) in organList"
								:label="item.dw"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="经费金额" prop="allocate_money">
						<el-input-number v-model="formData.allocate_money" :min="1" label="请输入缴费金额"></el-input-number>
					</el-form-item>
					<el-form-item label="经  办  人" class="form_item" prop="agent">
						<el-input v-model="formData.agent"  placeholder="请输入经办人"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeWin()">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dwgl,djxc } from '@/axios'
	let that;
	export default{
		data(){
			return{
				formData:{
					pid:this.$store.state.user.userinfo.dwid,
					id:"",
					allocate_money: "",
					allocate_class:"",
					allocate_time: "",
					agent: "",
					funds_class:"",
					flag:[],
					uid:[],
				},
				rules:{
					// 经费名称检测
					allocate_class: [{ required: true, message: '请输入经费名称', trigger: 'blur' }],
					// 经费金额检测
					allocate_money: [{ required: true, message: '请输入经费金额', trigger: 'blur' }],
					// 经费经办人检测
					agent: [{ required: true, message: '请输入经办人姓名', trigger: 'blur' }],
					// 经费时间检测
					allocate_time: [{ required: true, message: '请选择时间', trigger: 'blur' }],
					// 经费类型
					funds_class: [{ required: true, message: '请选择经费分类', trigger: 'blur' }],
					uid: [{ required: true, message: '请选择下拨组织', trigger: 'blur' }],
				},
				arr:[],
				edit:false,
				organList:[],
				props: { multiple: true },
				showJfWin:false,
				title:"新增经费"
			}
		},
		created(){that = this;},
		props:{
			type:{
				type:String,
				default:'add'
			},
			flag:{
				type:String,
				default:""
			},
			id:{
				type:String,
				default:""
			}
		},
		methods:{
			// 关闭弹窗
			openWin(){
				that.showJfWin = true;
				if(that.$store.state.user.userinfo.flag == 1){
					that.organMember();
				}
			},
			// 关闭弹窗
			closeWin(){
				that.showJfWin = false;
				that.formData = {
					id:"",
					pid:that.$store.state.user.userinfo.dwid,
					allocate_money: "",
					allocate_class: "",
					allocate_time: "",
					agent: "",
					funds_class: '',
					uid:[],
					flag:[],
				};
				that.arr = [];
				that.$refs.form.resetFields();	
				that.$emit("dataList")				
			},
			// 提交
			submit(){
				// 经费下拨
				if(that.formData.funds_class==1){
					if(that.$store.state.user.userinfo.flag == 1){
						that.formData.pid = that.$store.state.user.userinfo.id;//党委拨款组织时候
					}else{
						that.formData.pid = that.$store.state.user.userinfo.pid;//拨款组织
					}
				}else{
					that.formData.pid = "";//支出
					that.formData.uid = [that.$store.state.user.userinfo.id];//支出
					that.formData.flag = [that.$store.state.user.userinfo.flag];//支出
				}
				that.$refs.form.validate(valid => {
					if(valid){
						if(that.type == 'add'){
							dwgl.addFunds(that.formData).then(res => {
								if(res.code == 200){
									that.closeWin();
								}
							})
						}else{
							dwgl.updateFunds(that.formData).then(res => {
								if(res.code == 200){
									that.closeWin();
								}
							})
						}
					}
				})
			},
			// 编辑绑定数据
			bindData(data){
				for(let val in data){
					for(let key in that.formData){
						if(val == key){
							if(val == "uid" || val == "flag"){
								that.formData[key][0] = data[val]
							}
							that.formData[key] = data[val]
						}
					}
				}
				that.organList.forEach(item => {
					if(data.uid == item.id&&data.flag == item.flag){
						that.arr = [item]
					}
				})
			},
			// 组织列表
			organMember(){
				djxc.partyOrgan({
					user_id:that.$store.state.user.userinfo.dwid,
					flag:that.$store.state.user.userinfo.flag,
				}).then(res => {
					that.organList = res.data;
				})
			},
			//选择组织
			changeDw(value){
				that.formData.uid = [];that.formData.flag = [];
				for(var key=0;key<value.length; key++){
					that.formData.uid.push(value[key].id)
					that.formData.flag.push(value[key].flag)
				}
			},
		},
		watch:{
			id:{
				immediate:true,
				handler(value){
					
				},
				deep:true
			},
			flag:{
				handler(value){
				},
				deep:true
			},
		}
	}
</script>

<style lang="scss">
	.zzgk_dialog{
		.el-dialog{
			z-index: 1000;
			width: 500px;
		}
	}
	.formData2{
		display: flex;
		justify-content: center;
		width: 100%;
		max-height: 400px;
		overflow-y: scroll;
		.el-form-item{
			display: flex;
			align-items: center;
		}
	}
</style>
